export default __webpack_public_path__ + "Config/open-id-connect-configuration.json?bust=02eb23eb9d4fc23f5c4354f34716afc1";